import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  H: number;
  eh: number;
  L: number;
  el: number;
  t2: number;
  e2: number;
  t1: number;
  e1: number;
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.CANTILEVER_2,
  image: "/images/assets/potence-2.png",
  submittedBy: SubmittingOrganization.PCM,
  inputs: [
    { key: "H", type: "dimension" },
    { key: "eh", type: "dimension" },
    { key: "L", type: "dimension" },
    {
      key: "el",
      type: "dimension",
    },
    { key: "t2", type: "dimension" },
    { key: "e2", type: "dimension" },
    { key: "t1", type: "dimension" },
    { key: "e1", type: "dimension" },
  ],
  build: (params, offset) => {
    const { H, L, eh, el, t2, e2, t1, e1 } = params;

    const bDelta = (t2 - eh) / 2;
    const rDelta = (t1 - el) / 2;

    return [
      {
        // Poteau vertical
        type: "polyline",
        points: [
          [offset[0], offset[1] - el - e1, offset[2]],
          [offset[0] + eh, offset[1] - el - e1, offset[2]],
          [offset[0] + eh, offset[1] - el - e1 - H, offset[2]],
          [offset[0], offset[1] - el - e1 - H, offset[2]],
          [offset[0], offset[1] - el - e1, offset[2]],
        ],
      },
      {
        // Renfort
        type: "polyline",
        points: [
          [offset[0] - rDelta, offset[1] - el, offset[2]],
          [offset[0] + eh + rDelta, offset[1] - el, offset[2]],
          [offset[0] + eh + rDelta, offset[1] - el - e1, offset[2]],
          [offset[0] - rDelta, offset[1] - el - e1, offset[2]],
          [offset[0] - rDelta, offset[1] - el, offset[2]],
        ],
      },
      {
        // Console horizontale
        type: "polyline",
        points: [
          [offset[0], offset[1], offset[2]],
          [offset[0] + L, offset[1], offset[2]],
          [offset[0] + L, offset[1] - el, offset[2]],
          [offset[0], offset[1] - el, offset[2]],
          [offset[0], offset[1], offset[2]],
        ],
      },
      {
        // Base
        type: "polyline",
        points: [
          [offset[0] - bDelta, offset[1] - H - el - e1, offset[2]],
          [offset[0] + eh + bDelta, offset[1] - H - el - e1, offset[2]],
          [offset[0] + eh + bDelta, offset[1] - H - el - e1 - e2, offset[2]],
          [offset[0] - bDelta, offset[1] - H - el - e1 - e2, offset[2]],
          [offset[0] - bDelta, offset[1] - H - el - e1, offset[2]],
        ],
      },
    ];
  },
};
export default asset;
